import * as React from 'react';

import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';

import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick}>
                <DataColumn kid='column3' name='Data' fieldName='eventDate' minWidth={200} maxWidth={200} align='left' />
                <DataColumn kid='column4' name='Utente' fieldName='userDescription' minWidth={200} maxWidth={200} align='left' />
                <DataColumn kid='column1' name='Stato' fieldName='stateDescription' minWidth={200} maxWidth={200} align='left' />
                <DataColumn kid='column2' name='Stato Precedente' fieldName='previousStateDescription' minWidth={200} maxWidth={200} align='left' />
            </DataList>
        </>
    );
}
